var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_23649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4804 3.69922C16.2127 3.69922 15.9948 3.91707 15.9948 4.18477C15.9948 4.45246 16.2127 4.67031 16.4804 4.67031C16.7481 4.67031 16.9659 4.4525 16.9659 4.18477C16.9659 3.91703 16.7481 3.69922 16.4804 3.69922Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.69531C8.29314 5.69531 6.36212 7.62633 6.36212 9.99984C6.36212 12.3734 8.29314 14.3044 10.6667 14.3044C13.0402 14.3044 14.9712 12.3734 14.9712 9.99988C14.9712 7.62637 13.0402 5.69531 10.6667 5.69531Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.184 0H6.14938C3.12622 0 0.666687 2.45953 0.666687 5.48273V14.5173C0.666687 17.5405 3.12622 20 6.14938 20H15.184C18.2072 20 20.6667 17.5405 20.6667 14.5173V5.48273C20.6667 2.45953 18.2072 0 15.184 0ZM10.6667 15.4856C7.64188 15.4856 5.1811 13.0248 5.1811 10C5.1811 6.9752 7.64192 4.51445 10.6667 4.51445C13.6915 4.51445 16.1523 6.97523 16.1523 10C16.1523 13.0248 13.6915 15.4856 10.6667 15.4856ZM16.4804 5.85297C15.5614 5.85297 14.8138 5.10531 14.8138 4.18633C14.8138 3.26734 15.5614 2.51965 16.4804 2.51965C17.3994 2.51965 18.147 3.2673 18.147 4.18629C18.147 5.10527 17.3994 5.85297 16.4804 5.85297Z",
    fill: "#6B6B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_23649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666687)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7dc3da1070d80da94cfb6ef3f469d186.svg";
export { ForwardRef as ReactComponent };